module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.newsObject) ? _c('div', {
    staticClass: "news-item"
  }, [_c('div', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    model: {
      value: (_vm.newsObject.title),
      callback: function($$v) {
        _vm.$set(_vm.newsObject, "title", $$v)
      },
      expression: "newsObject.title"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "date-picker",
    attrs: {
      "editable": false,
      "type": "date",
      "placeholder": "Дата"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "placeholder": "Текст информации"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadNewsPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить фото\n    ")]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })]), _vm._v(" "), (_vm.newsObject.photos.length) ? _c('div', [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.newsObject.photos), function(photo) {
    return _c('swiper-slide', {
      key: photo
    }, [(_vm.isNew) ? _c('div', {
      staticClass: "photo-container column"
    }, [_c('div', {
      staticClass: "centered"
    }, [_c('img', {
      attrs: {
        "src": photo.photo
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "delete-icon",
      attrs: {
        "src": "/static/img/icons/delete.svg"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeletePhoto(photo)
        }
      }
    })])]) : _c('div', {
      staticClass: "photo-container column"
    }, [_c('div', {
      staticClass: "centered"
    }, [_c('img', {
      staticClass: "column",
      attrs: {
        "src": "/upload/photos/" + photo
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "delete-icon",
      attrs: {
        "src": "/static/img/icons/delete.svg"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeletePhoto(photo)
        }
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "button is-fullwidth",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-fullwidth",
    attrs: {
      "to": {
        name: 'News'
      }
    }
  }, [_vm._v("ОТМЕНА")]), _vm._v(" "), (!_vm.isNew) ? _c('span', {
    staticClass: "button is-fullwidth is-danger",
    on: {
      "click": function($event) {
        return _vm.deleteNews(_vm.newsObject.id)
      }
    }
  }, [_vm._v("УДАЛИТЬ")]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff841aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/NewsItem.vue
// module id = 906
// module chunks = 0